import { setFilters } from '@/app/common/reducers/filterSlice';
import type { AdvancedFiltersState } from '@/app/common/components/filters/filterTypes';
import { convertToQueryString } from '@/utils/queryString';
import {
  Button,
  Dropdown,
  Form,
  OverlayTrigger,
  Popover
} from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { useSearchParams } from 'react-router-dom';
import { useState, type FormEvent } from 'react';

type FiltersRootState = {
  filters: AdvancedFiltersState;
};

const CompetitorsCustomPosFilters = () => {
  const [customStart, setCustomStart] = useState<string | number>(1);
  const [customLimit, setCustomLimit] = useState('');
  const [showFilterMenu, setShowFilterMenu] = useState(false);
  const dispatch = useDispatch();
  const currentFilters = useSelector(
    (state: FiltersRootState) => state.filters
  );

  const [, setSearchParams] = useSearchParams();
  const handleFilterClick = (start: number, limit?: number | string) => {
    const filters: AdvancedFiltersState = {
      rank: {
        title: 'رتبه ',
        operator: 'and',
        filterModes: [
          {
            mode: 'greaterthanorequals',
            value: `${start}`,
            key: 1
          },
          ...(limit !== undefined
            ? [
                {
                  mode: 'lessthanorequals',
                  value: `${limit}`,
                  key: 2
                }
              ]
            : [])
        ]
      }
    };
    dispatch(setFilters({ ...currentFilters, ...filters }));
    setSearchParams(convertToQueryString({ ...currentFilters, ...filters }));
    setShowFilterMenu(false);
  };
  const handleCustomSubmit = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (customLimit) {
      handleFilterClick(Number(customStart), customLimit);
    }
  };

  return (
    <OverlayTrigger
      show={showFilterMenu}
      trigger="click"
      onToggle={() => setShowFilterMenu(false)}
      rootClose
      placement="top"
      overlay={
        <Popover
          id="custom_filter_menu"
          className="react-select__menu"
          style={{ maxWidth: '100%', minWidth: 200 }}
        >
          <style>
            {`
        #custom_filter_menu .popover-arrow{ display:none }
        `}
          </style>
          <Popover.Body className="p-2">
            <Dropdown.Item
              className="link-600 border-bottom fs--1 justify-content-between d-flex align-items-center gap-1 p-1"
              onClick={() => handleFilterClick(10)}
            >
              بالای ۱۰
            </Dropdown.Item>
            <Dropdown.Item
              className="link-600 border-bottom fs--1 justify-content-between d-flex align-items-center gap-1 p-1"
              onClick={() => handleFilterClick(20)}
            >
              بالای ۲۰
            </Dropdown.Item>
            <Dropdown.Item
              className="link-600 border-bottom fs--1 justify-content-between d-flex align-items-center gap-1 p-1"
              onClick={() => handleFilterClick(50)}
            >
              بالای ۵۰
            </Dropdown.Item>
            <div onClick={e => e.stopPropagation()} className="p-2 mt-2">
              <Form onSubmit={handleCustomSubmit}>
                <Form.Label> بازه دلخواه </Form.Label>
                <div className="input-group position-relative input-group-sm">
                  <Form.Control
                    size="sm"
                    type="number"
                    placeholder="از"
                    style={{ width: 50 }}
                    value={customStart}
                    onChange={e => setCustomStart(e.target.value)}
                  />
                  <Form.Control
                    size="sm"
                    type="number"
                    style={{ width: 50 }}
                    placeholder="تا"
                    value={customLimit}
                    onChange={e => setCustomLimit(e.target.value)}
                  />
                </div>
                <Button
                  type="submit"
                  size="sm"
                  variant="falcon-primary"
                  className="mt-2 w-100"
                >
                  اعمال
                </Button>
              </Form>
            </div>
          </Popover.Body>
        </Popover>
      }
    >
      <Button
        size="lg"
        variant="secondary"
        onClick={() => setShowFilterMenu(s => !s)}
        className="m-0 fs-0 h-100 cursor-pointer d-flex align-items-center"
      >
        رتبه میانگین
      </Button>
    </OverlayTrigger>
  );
};

export default CompetitorsCustomPosFilters;
